// ────────────────────────────────────────────────────────────────
// Bandeau « données d'exemple » — société d'essai encore peuplée par les
// données créées à l'inscription (server/seedDemoData.js, is_demo=1).
// Ces données sont déjà exclues des indicateurs côté serveur ; le bandeau
// le dit, et propose de les supprimer en un clic (admin, avec confirmation).
// Ne concerne que la société active, et seulement les lignes marquées démo.
// ────────────────────────────────────────────────────────────────
import { useState, useEffect } from "react";
import api from "../services/api";

const TABLE_LABELS = {
  invoices: "factures", customers: "clients", bank_accounts: "compte bancaire",
  transactions: "écritures bancaires", crm_contacts: "contacts", crm_opportunities: "opportunités",
  stock_products: "produits", stock_orders: "commandes",
};

const describe = (tables = {}) =>
  Object.entries(tables).map(([t, n]) => `${n} ${TABLE_LABELS[t] || t}`).join(", ");

export default function DemoDataBanner({ user, companyId, onPurged }) {
  const [info, setInfo]           = useState(null);
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy]           = useState(false);
  const [message, setMessage]     = useState("");

  useEffect(() => {
    setInfo(null); setMessage(""); setConfirming(false);
    if (!companyId) return;
    api.onboarding.demoData().then(setInfo).catch(() => setInfo(null));
  }, [companyId]);

  if (!info?.total && !message) return null;

  const isAdmin = user?.role === "admin";

  const purge = async () => {
    setBusy(true);
    try {
      const r = await api.onboarding.purgeDemoData();
      const kept = describe(r.kept);
      setMessage(`Données d'exemple supprimées.${kept ? ` Conservées car utilisées dans vos vraies données : ${kept}.` : ""}`);
      setInfo(r.remaining);
      setConfirming(false);
      onPurged?.();
    } catch (err) {
      setMessage(err.message || "Suppression impossible.");
    } finally {
      setBusy(false);
    }
  };

  const box = {
    margin: "0 0 16px", padding: "10px 14px", borderRadius: 10, fontSize: 13,
    background: "var(--badge-info-bg)", color: "var(--badge-info-text)",
    border: "1px solid var(--border)", display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap",
  };
  const btn = { border: "none", borderRadius: 6, padding: "5px 12px", fontSize: 12, fontWeight: 700, cursor: busy ? "not-allowed" : "pointer" };

  if (message && !info?.total) {
    return <div style={box} role="status">✓ {message}</div>;
  }

  return (
    <div style={box} role="status">
      <span style={{ flex: 1, minWidth: 220 }}>
        <strong>Données d'exemple</strong> — votre espace contient des données fictives créées à l'inscription
        ({describe(info.tables)}). Elles ne sont pas comptées dans vos indicateurs.
        {message && <> · {message}</>}
      </span>
      {isAdmin && !confirming && (
        <button style={{ ...btn, background: "var(--danger)", color: "#fff" }} onClick={() => setConfirming(true)}>
          Supprimer les données d'exemple
        </button>
      )}
      {isAdmin && confirming && (
        <>
          <span style={{ fontWeight: 700 }}>Supprimer définitivement ces données fictives ? Vos propres données ne sont pas touchées.</span>
          <button style={{ ...btn, background: "var(--danger)", color: "#fff" }} disabled={busy} onClick={purge}>
            {busy ? "Suppression…" : "Confirmer la suppression"}
          </button>
          <button style={{ ...btn, background: "transparent", color: "inherit", border: "1px solid currentColor" }} disabled={busy} onClick={() => setConfirming(false)}>
            Annuler
          </button>
        </>
      )}
    </div>
  );
}
